

const selector = '.search-loading-indicator';

let $elem = null;
let open = false;

function init() {
	$elem = $(selector);
}

function show() {
	if (open) return false;
	open = true;

	$elem.show();

	// no one likes a forver spinner
	setTimeout(() => $elem.hide(), 1000 * 3);
}

function hide() {
	if (!open) return false;
	open = false;
	$elem.hide();
}

export const spinner = {
	init,
	show,
	hide
};